import { useQuery } from '@tanstack/react-query';
import type { CanonicalAggregateUnavailable } from './useSpendByCategory';

export interface UseSpendByMerchantParams {
  accountId?: string | null;
  dateFrom?: string;
  dateTo?: string;
  enabled?: boolean;
}

const unavailable: CanonicalAggregateUnavailable = {
  kind: 'unavailable',
  reason: 'canonical_aggregate_unavailable',
  buckets: [],
  currency: null,
};

export function useSpendByMerchant(params: UseSpendByMerchantParams = {}) {
  const { accountId, dateFrom, dateTo, enabled = true } = params;
  return useQuery({
    queryKey: ['spend-by-merchant', {
      accountId,
      dateFrom,
      dateTo,
      availability: 'canonical_aggregate_unavailable',
    }],
    enabled,
    queryFn: async (): Promise<CanonicalAggregateUnavailable> => unavailable,
  });
}

export default useSpendByMerchant;
